import t, { forwardRef as p } from "react";
import c from "../Loader/Loader.js";
const i = p(function({ children: a, variant: r, inverse: n, size: f = "regular", testId: d = "fs-button", loading: u, loadingLabel: s, icon: e, iconPosition: o = "left", disabled: l, ...b }, m) {
  return t.createElement(
    "button",
    { ref: m, "data-fs-button": !0, "data-fs-button-inverse": n, "data-fs-button-size": f, "data-fs-button-loading": u, "data-fs-button-variant": r, disabled: l, "data-testid": d, ...b },
    t.createElement(
      "div",
      { "data-fs-button-wrapper": !0 },
      u && t.createElement(
        "p",
        { "data-fs-button-loading-label": !0 },
        s,
        t.createElement(c, { variant: r === "primary" && !n ? "light" : "dark" })
      ),
      !!e && o === "left" && t.createElement("span", { "data-fs-button-icon": !0 }, e),
      a && t.createElement("span", null, a),
      !!e && o === "right" && t.createElement("span", { "data-fs-button-icon": !0 }, e)
    )
  );
}), v = i;
export {
  v as default
};
